import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ReplaySubject} from 'rxjs';
import {Document} from '../../../shared/interface/document';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DocumentService} from '../../../shared/services/document.service';

@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss']
})
export class DocumentDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  documentId: string;
  documentObject?: Document;
  document: ReplaySubject<Document> = new ReplaySubject<Document>(1);
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.documentId = params.id;
        this.loadDocument();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadDocument(): void {
    this.documentService.get(this.documentId).subscribe((document: Document) => {
      this.document.next(document);
      this.documentObject = document;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych dokumentu', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
